import { IAllergy } from '../caremap/ICareMap';
import { CareMapState } from '../caremap/CareMapState';
import { MixPanelEventEmitter } from '../metrics/MixPanelEventEmitter';
import { StructuredRecordFormState } from './structured-records/StructuredRecordFormState';
import { AllergyDescriptor } from './AllergyDescriptor';

export class AllergyFormState extends StructuredRecordFormState<IAllergy> {
    static inject = () => [CareMapState, MixPanelEventEmitter, AllergyDescriptor];

    constructor(
        careMapState: CareMapState,
        mixpanel: MixPanelEventEmitter,
        protected descriptor: AllergyDescriptor
    ) {
        super(careMapState, mixpanel);
    }
}
